package app.smartcoding.realrate.presentation.util

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import app.smartcoding.realrate.domain.model.LanguageCode
import org.jetbrains.compose.resources.Font
import realrate.shared.generated.resources.NotoSans
import realrate.shared.generated.resources.NotoSansArabic
import realrate.shared.generated.resources.NotoSansBengali
import realrate.shared.generated.resources.NotoSansDevanagari
import realrate.shared.generated.resources.NotoSansJP
import realrate.shared.generated.resources.NotoSansKR
import realrate.shared.generated.resources.NotoSansSC
import realrate.shared.generated.resources.NotoSansThai
import realrate.shared.generated.resources.Res

@Composable
fun fontFamilyForLanguage(languageCode: LanguageCode): FontFamily {

    return when (languageCode.code) {
        // Арабски езици
        "ar", "ur" -> FontFamily(
            Font(Res.font.NotoSansArabic, FontWeight.Normal),
            Font(Res.font.NotoSansArabic, FontWeight.Bold),
            Font(Res.font.NotoSans)
        )

        // Китайски (Simplified)
        "zh" -> FontFamily(
            Font(Res.font.NotoSansSC),
            Font(Res.font.NotoSans)
        )

        // Японски
        "ja" -> FontFamily(
            Font(Res.font.NotoSansJP),
            Font(Res.font.NotoSans)
        )

        // Корейски
        "ko" -> FontFamily(
            Font(Res.font.NotoSansKR),
            Font(Res.font.NotoSans)
        )

        // Тайландски
        "th" -> FontFamily(
            Font(Res.font.NotoSansThai),
            Font(Res.font.NotoSans)
        )

        // Бенгалски
        "bn" -> FontFamily(
            Font(Res.font.NotoSansBengali),
            Font(Res.font.NotoSans)
        )

        // Хинди (Деванагари)
        "hi" -> FontFamily(
            Font(Res.font.NotoSansDevanagari),
            Font(Res.font.NotoSans)
        )

        // За всички останали (En, Bg, De, Fr, Es, Ru и т.н.) ползваме основния
        else -> FontFamily(
            Font(Res.font.NotoSans),
        )
    }
}